import v2026 from '@/sui/data/sheets/edit/badicause/2026'

import {
  buildConvertFromFieldList
} from '@/sui/data/sheets/convert/tools'

export default {
  '2026': buildConvertFromFieldList(v2026.sheet.fields)
}
